<template lang="pug">
vm-prompt(@vm-cancel="close" @vm-accept="cancelPurchaseOrder()" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isCancelPurchaseOrderModalVisible" :vm-title="$t('purchase_orders.cancel_order')")
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-chips(:label='$t("purchase_orders.email")' :placeholder='$t("purchase_orders.name_placeholder")' :danger="$v.form.emails.$invalid && $v.form.emails.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.email') })" v-model="form.emails" remove-icon="close-outline")
          vm-chip(:key="value.id" @click="remove(value.id)" v-for="value in form.emails" closable close-icon="close-outline") {{ value.email }}
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrders')

export default {
  name: 'ModalCancelPurchaseOrder',
  mixins: [ModalMixin1],
  props: {
    emails: {
      default: () => [],
      type: Array
    }
  },
  validations () {
    return {
      form: {
        emails: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isCancelPurchaseOrderModalVisible'])
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setCancelPurchaseOrderModalVisible',
      'actionRecord'
    ]),
    remove (item) {
      this.form.emails.splice(this.form.emails.indexOf(item), 1)
    },
    cancelPurchaseOrder () {
      this.form.purchaseOrder.id && this.actionRecord({ id: this.form.purchaseOrder.id, action: 'cancel', emails: this.form.emails, details: this.form.purchaseOrder.details })
      this.setCancelPurchaseOrderModalVisible(false)
    },
    close () {
      this.setCancelPurchaseOrderModalVisible(false)
    }
  }
}
</script>
